import { ImportUserSchedule } from './import-schedule.component';

export default ImportUserSchedule;
